import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export interface LoginData {
  access_token: string;
  token_type: string;
  expires_in: number;  // Changed to number to match the "3600" format
  user: {
    id: number
    role_id: string
    email: string
    name: string
    address: string
    city: string
    state: string
    postal_code: string
    phone: string
    email_verified_at: any
    created_at: string
    updated_at: string
    profile_updated: boolean
  };
}

export type RegisteredUser = {
    name: string
    email: string;
    password: string;
    confirm_password: string;
    role: string;
}

export type ResetUser = {
  email: string;
}

export type ResetPasswordOTPUser = {
  email: string;
  token: string;
};


export const userData = atomWithStorage<LoginData | undefined>("autoload", JSON.parse(localStorage.getItem("autoload")!) ?? undefined);

export const registerUserData = atom<RegisteredUser[]>([])

export const resetUserData = atom<ResetUser[]>([]);

export const resetPasswordOtpData = atom<ResetPasswordOTPUser | null>(null);